import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-un-authorize',
  templateUrl: '../views/un-authorize.component.html',
  styleUrls: ['../css/un-authorize.component.css']
})
export class UnAuthorizeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/components/un-authorize.component.ts